import React from 'react';
import InspectionCompletenessSection from './InspectionCompletenessSection';

// The section is shared with the Slope and Bridge dashboards — see
// InspectionCompletenessSection for the full implementation and the per-kind configuration.
const HighMastInspectionCompletenessSection = () => <InspectionCompletenessSection kind="highMast" />;

export default HighMastInspectionCompletenessSection;
